import { createItemStorage } from "./createItemStorage";

export const apiMock = ({ storage }) =>
	createItemStorage(storage, "x-api-mock");
